import React from 'react';
import { ArcStack } from '@src/core/ui';
import { InfoCard, FirmwareBanner } from './components';
import { useOverviewPanel } from './hooks';

const OverviewPanel: React.FC = () => {
  const {
    selectedDrone,
    hasDrone,
    hubName,
    flightStats,
    firmwareBannerView,
    droneVersion,
    isFirmwareLoading,
    handleFirmwareUpdate,
    isUpdating,
  } = useOverviewPanel();

  return (
    <ArcStack spacing={3}>
      <FirmwareBanner
        view={firmwareBannerView}
        onUpdate={handleFirmwareUpdate}
        isUpdating={isUpdating}
        isLoading={isFirmwareLoading}
      />

      <ArcStack direction='row' gap={3}>
        <InfoCard label='Drone Name' value={selectedDrone?.name} />
        <InfoCard label='Serial Number' value={selectedDrone?.serialNumber} />
      </ArcStack>

      <ArcStack direction='row' gap={3}>
        <InfoCard label='Status' value={selectedDrone?.status} />
        <InfoCard label='Battery' value={hasDrone ? `${selectedDrone?.batteryHealth}%` : '—'} />
      </ArcStack>

      <ArcStack direction='row' gap={3}>
        <InfoCard label='HUB' value={hubName} />
        <InfoCard label='Drone Version' value={droneVersion} isLoading={isFirmwareLoading} />
      </ArcStack>

      <ArcStack direction='row' gap={3}>
        <InfoCard label='Total Flight Count' value={flightStats.count} isLoading={flightStats.isLoading} />
        <InfoCard label='Total Flight Time' value={flightStats.time} isLoading={flightStats.isLoading} />
        <InfoCard label='Total Flight Distance' value={flightStats.distance} isLoading={flightStats.isLoading} />
      </ArcStack>
    </ArcStack>
  );
};

export default OverviewPanel;
